export const DEFAULT_OPTIONS = {
    root: null,
    rootMargin: '0px',
    threshold: 0,
};
